<template>
  <h2 class="d-flex w-full h-full justify-content-center align-items-center">{{ $t('app.something_wrong') }}</h2>
</template>

<script setup lang="ts"></script>
